module.exports = __webpack_public_path__ + "img/photo-film-music.f641d949.svg";